import React, { useEffect } from 'react'

export const RawSvg: React.FC<{ path: string }> = ({ path }) => {
  const [svg, setSvg] = React.useState<string>()
  const [error, setError] = React.useState<boolean>(false)
  const controller = new AbortController()
  useEffect(() => {
    setSvg(undefined)
    setError(false)
    fetch(path, { signal: controller.signal })
      .then((res) => {
        if (!res.ok) {
          setError(true)
          return Promise.reject()
        }
        return res.text()
      })
      .then((text) => setSvg(text))
      .catch((err) => err.name !== 'AbortError' && console.error(err))
    return () => {
      controller.abort()
    }
  }, [path])
  if (!svg || error) return null
  return <span dangerouslySetInnerHTML={{ __html: svg }} />
}
